<template>
    <div>

        <el-card class="box-card">
            <div style="display: flex;background: white">
                <div style="width: 50%;text-align: left;display: flex">
                    <el-button type="primary" size="mini" @click="download">{{$t('getapi[6506]')}}</el-button>
                    <el-button type="primary" size="mini" @click="deleteAll">{{$t('getapi[686]')}}</el-button>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
                            accept=".xlsx"
                            style="margin-left: 8px"
                    >
                        <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6507]')}}</el-button>
                    </el-upload>
                </div>
                <div style="width: 50%;text-align: right">
                    <el-button type="primary" size="mini" @click="save(1)">{{$t('getapi[370]')}}</el-button>
                    <!--<el-button type="primary" size="mini">关闭</el-button>-->
                </div>
            </div>
        </el-card>
        <div id="xpane-0">
            <vxe-table :data="datajson"
                       show-overflow
                       ref='CloseSoTable'
                       size="mini" :loading="loading" :height="tableHeight" stripe border resizable>
                <vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="errormsg" :title="$t('getapi[357]')"
                                  width="150px"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="warmmsg" :title="$t('getapi[241]')"
                                  width="150px"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="count_plan_sign" :title="$t('getapi[7436]')"
                                  width="100"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="count_date" :title="$t('getapi[4042]')" width="150px">
                </vxe-table-column>
                <vxe-table-column show-footer-overflow field="count_card_flag_name" :title="$t('getapi[7449]')"
                                  width="100"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="count_person" :title="$t('getapi[7440]')"
                                  width="80px"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="count_card_issue_no" :title="$t('getapi[7430]')"
                                  width="150px"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="count_card_no" :title="$t('getapi[7431]')"
                                  width="100px"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="count_area" :title="$t('getapi[7432]')"
                                  width="100px"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="so_code" :title="$t('getapi[7433]')"
                                  width="100px"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[112]')"
                                  width="100px"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')"
                                  width="100px"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="routing_no" :title="$t('getapi[573]')"
                                  width="100px"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="count_measure" :title="$t('getapi[888]')"
                                  width="100px"></vxe-table-column>
                <vxe-table-column field="count_qty" :title="$t('getapi[1628]')" width="100px" align="right">
                    <template slot-scope="scope">
                        {{ scope.row.count_qty | thousandth}}
                    </template>
                </vxe-table-column>
                <vxe-table-column show-footer-overflow field="cargo_position" :title="$t('getapi[1957]')"
                                  width="100px"></vxe-table-column>
            </vxe-table>
        </div>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: 'dnimport',
        computed: {
            tableHeight() {
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                fileList: [],
                itevisible: false,
                ids: '',
                showloading: '',
                DbTbNames: '', //表名
                datajson: [],
                loading: false, // 主表加载状态
                uploadurl: '',
                scrollTop: 0,
            };
        },
        created() {
            setTimeout(() => {
                this.datajson = [];
            }, 1000)
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Fin/Check/CardExportBatchFile?token=' + token;
            this.btnauthority();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        mounted() {
            console.log('mounted');
            this.btnauthority();
        },
        activated() {
            let that = this
            setTimeout(() => {
                that.$refs.CloseSoTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                }, false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.CloseSoTable.bodyWrapper.scrollTop = this.scrollTop;
                }, 13)
            })
        },
        methods: {
            btnauthority() {
                let that = this;
            },
            deleteAll() {
                let that = this;
                let selectRecords = this.$refs.CloseSoTable.getCheckboxRecords();
                for (let i = selectRecords.length - 1; i >= 0; i--) {
                    let line = this.$refs.CloseSoTable.getRowIndex(selectRecords[i]);
                    that.datajson.splice(line, 1);
                }
            },
            download() {
                let param = {
                    url: '/Fin/Check/GetCardExportTemplate'
                }
                Array.methods.DownLoadTemp(param);
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        if (file.response.DataContent.length > 0) {
                            that.datajson = file.response.DataContent;
                        } else {
                            that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                        }
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg))
                } else {
                    if (res.DataContent.length > 0) {
                        that.datajson = res.DataContent;
                    } else {
                        that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                    }

                }
                that.fileList = [];
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]') + ':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview" + file);
            },
            // 保存备注数据
            save(val) {
                let that = this;
                if (that.datajson.length == 0) {
                    that.$message.warning(that.$t('getapi[8712]'));//'请添加导入数据！'
                    return;
                }
                let parm = {
                    type: val,
                    ls: that.datajson
                }
                that.$http.urlpost('/Fin/Check/CardExportSave', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    } else if (res.Success == 2) {
                        that.datajson = res.DataContent.dt
                    } else if (res.Success = 3) {
                        that.datajson = res.DataContent.dt
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.save(2)
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
        }
    };
</script>

<style lang="scss" scoped>
    span.label-fade-enter {
        font-size: medium;
        margin-right: 20px;
    }
</style>
<style>
    .el-message-box {
        width: 600px;
    }
</style>
